import { render, staticRenderFns } from "./ExceptionHeader.vue?vue&type=template&id=2277f552&scoped=true&"
import script from "./ExceptionHeader.vue?vue&type=script&lang=js&"
export * from "./ExceptionHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionHeader.vue?vue&type=style&index=0&id=2277f552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277f552",
  null
  
)

export default component.exports